import apiClient from "../apiClient";
import ENDPOINTS from "../endpoints";

export const getProfile = () => {
  return apiClient.get(ENDPOINTS.PROFILE);
};


// 📝 Dashboard
export const dashboardUser = async (data) => {
  const response = await apiClient.get(ENDPOINTS.DASHBOARD_DETAILS);
  return response.data;
};
export const dashboardUserFiles = async (data,intValue) => {
  const response = await apiClient.get(
    `${ENDPOINTS.DASHBOARD_DETAILS_FILE}?actionName=${intValue}`,
    {
      responseType: "blob", // 👈 VERY IMPORTANT
    }
  );
  return response.data;
};

export const updateProfile = async (data) => {
  const response = await apiClient.post(ENDPOINTS.DASHBOARD_DETAILS, data);
  return response.data;
};

export const updateProfileImage = async (data) => {
  const response = await apiClient.post(ENDPOINTS.UPDATE_FILE, data);
  return response.data;
};

export const updateProfileFile = async (data) => {
  const response = await apiClient.post(ENDPOINTS.UPDATE_FILE, data);
  return response.data;
}

export const getUserMembers = async () => {
  const response = await apiClient.get(ENDPOINTS.GET_MEMBERS);
  return response.data;
}

// export const getDriversList = async ({ page = 1, search = "", page_size = 5 }) => {
//   const response = await apiClient.get(`${ENDPOINTS.GET_DRIVERS}?page=${page}`);
//   return response.data;
// }
export const getDriversList = async ({ page = 1, search = "", page_size = 5 }) => {
  const response = await apiClient.get(ENDPOINTS.GET_DRIVERS, {
    params: {
      page,
      search,
      page_size,
    },
  });
  return response.data;
};

export const getDriverDetails = async (dl_num) => {
  const response = await apiClient.get(ENDPOINTS.GET_DRIVERS, {
    params: { driverId: dl_num },
  });
  return response.data;
};

export const setDriverDetails = async (dl_num, actionId) => {
  const response = await apiClient.get(ENDPOINTS.GET_DRIVERS, {
    params: { driverId: dl_num, actionId: actionId },
  });
  return response.data;
}

export const addMember = async (data) => {
  const response = await apiClient.post(ENDPOINTS.ADD_MEMBER, data);
  return response.data;
}

